'use client';

import { c as _c } from "react/compiler-runtime";
import { useIsMounted } from '@repo/hooks';
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Button } from '../_base/Button';
import { Text } from '../typography/Text';
const sizeConfig = {
  sm: {
    button: 'iconSm',
    icon: 'size-3'
  },
  md: {
    button: 'icon',
    icon: 'size-4'
  },
  lg: {
    button: 'iconLg',
    icon: 'size-5'
  }
} as const;
type DarkModeToggleSize = keyof typeof sizeConfig;
interface DarkModeToggleProps {
  size?: DarkModeToggleSize;
}
export function DarkModeToggle(t0) {
  const $ = _c(16);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const config = sizeConfig[size];
  const {
    theme,
    setTheme
  } = useTheme();
  const mounted = useIsMounted();
  let t2;
  if ($[0] !== setTheme || $[1] !== theme) {
    t2 = () => {
      bb6: switch (theme) {
        case "light":
          {
            setTheme("dark");
            break bb6;
          }
        case "dark":
          {
            setTheme("system");
            break bb6;
          }
        case "system":
        default:
          {
            setTheme("light");
          }
      }
    };
    $[0] = setTheme;
    $[1] = theme;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const cycleTheme = t2;
  let t3;
  if ($[3] !== config.icon || $[4] !== theme) {
    t3 = () => {
      switch (theme) {
        case "light":
          {
            return <Sun className={config.icon} />;
          }
        case "dark":
          {
            return <Moon className={config.icon} />;
          }
        case "system":
        default:
          {
            return <Monitor className={config.icon} />;
          }
      }
    };
    $[3] = config.icon;
    $[4] = theme;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const getIcon = t3;
  const t4 = mounted ? `Current theme: ${theme}` : "Toggle theme";
  let t5;
  if ($[6] !== config.icon || $[7] !== getIcon || $[8] !== mounted) {
    t5 = mounted ? getIcon() : <Monitor className={config.icon} />;
    $[6] = config.icon;
    $[7] = getIcon;
    $[8] = mounted;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text className="sr-only">Toggle theme</Text>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== config.button || $[12] !== cycleTheme || $[13] !== t4 || $[14] !== t5) {
    t7 = <Button variant="secondary" size={config.button} onClick={cycleTheme} aria-label={t4}>{t5}{t6}</Button>;
    $[11] = config.button;
    $[12] = cycleTheme;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}